// has number
const hasNumber = (number) => new RegExp(/[0-9]/).test(number);

// has mix of small and capitals
const hasMixed = (number) => new RegExp(/[a-z]/).test(number) && new RegExp(/[A-Z]/).test(number);

// has special chars
const hasSpecial = (number) => new RegExp(/[!#@$%^&*)(+=._-]/).test(number);

// set color based on password strength
export const strengthColor = (count) => {
  if (count < 1) return { level: count, label: 'Muito fraca', color: 'error.main' };
  if (count < 2) return { level: count, label: 'Fraca', color: 'warning.main' };
  if (count < 3) return { level: count, label: 'Normal', color: 'warning.dark' };
  if (count < 4) return { level: count, label: 'Boa', color: 'success.main' };
  if (count < 5) return { level: count, label: 'Forte', color: 'success.dark' };
  if (count < 6) return { level: count, label: 'Muito forte', color: 'success.dark' };
  return { level: count, label: 'Muito forte', color: 'success.dark' };
};

// password strength indicator
export const strengthIndicator = (number) => {
  let strengths = 0;
  if (number.length > 5) strengths += 1;
  if (number.length > 7) strengths += 1;
  if (hasNumber(number)) strengths += 1;
  if (hasSpecial(number)) strengths += 1;
  if (hasMixed(number)) strengths += 1;
  return strengths;
};
